<template>
  <div class="c-modal c-modal--rewards-filter">
    <section class="c-modal__box c-modal--rewards-filter__box">
      <div class="c-modal__box__header t-modal-header">
        <h2 class="c-modal__box__header__title t-modal-header__text">
          {{ $t('web.catalog_rewards_filter_modal.modal_title') }}
        </h2>

        <div class="c-modal__box__header__close">
          <button
            @click = "$emit('close')"
            class  = "c-modal__box__header__close__button t-modal-header__close"
          >
            <i class="fa fa-close"></i>
          </button>
        </div>
      </div>


      <rewards-filters ref="rewardsFilters"></rewards-filters>


      <div class="c-modal__box__actions c-modal--rewards-filter__box__actions">
        <div class="c-modal--rewards-filter__box__actions__left">
          <button
            class  = "c-modal__box__actions__button t-button-info"
            @click = "clearFilters"
          >
            {{ $t('web.catalog_rewards_filter_modal.clear_button') }}
          </button>
        </div>

        <div class="c-modal--rewards-filter__box__actions__right">
          <button
            class  = "c-modal__box__actions__button t-button-plain"
            @click = "close"
          >
            {{ $t('web.catalog_rewards_filter_modal.cancel_button') }}
          </button>
          <button
            class  = "c-modal__box__actions__button
                      t-button-primary
                      qa-apply-filters-button"
            @click = "applyFilters"
          >
            {{ $t('web.catalog_rewards_filter_modal.apply_button') }}
          </button>
        </div>
      </div>
    </section>


    <div class="c-modal__overlay"></div>
  </div>
</template>




<script>
import RewardsFilters from '@/views/components/catalog/RewardsFilters'

export default {
  name: 'RewardsFilterModal',

  components: { RewardsFilters },

  methods: {
    /**
     * Apply the selected filters and close the modal.
     *
     * @return {void}
     */
    applyFilters () {
      this.close()
      this.$refs.rewardsFilters.applyFilters()
    },

    /**
     * Clear the selected filters.
     *
     * @return {void}
     */
    clearFilters () {
      this.$refs.rewardsFilters.clearFilters()
    },

    /**
     * Close the modal.
     *
     * @return {void}
     */
    close () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// RewardsFilterModal.vue?7f04e88e